import inputValidation from "../../../utils/inputValidation";
import { apiT, K } from "./apiServiceI18n";

const MAX_NAME_LEN = 50;

/**
 * Same rules as inbound/outbound template names ({@link inputValidation}) plus '%' is disallowed.
 * @returns {{ ok: boolean, message?: string }}
 */
export function validateApiOrWorkflowName(name) {
  const trimmed = (name ?? "").trim();
  if (!trimmed) {
    return { ok: false, message: apiT(K.BOX_MSG_NAME_REQUIRED) };
  }
  if (trimmed.length > MAX_NAME_LEN) {
    return {
      ok: false,
      message: apiT(K.BOX_MAX_LENGTH_FOR_NAME_IS).replace(/\{0\}/, String(MAX_NAME_LEN)),
    };
  }
  if (trimmed.includes("%")) {
    return {
      ok: false,
      message: apiT(K.BOX_TEM_NAMES_CANNOT_CONTAIN_CERTAIN_CHARS_OR_SPACES),
    };
  }
  const iv = inputValidation(trimmed);
  if (iv === "invalid") {
    return {
      ok: false,
      message: apiT(K.BOX_TEM_NAMES_CANNOT_CONTAIN_CERTAIN_CHARS_OR_SPACES),
    };
  }
  return { ok: true };
}

/**
 * @returns {{ ok: boolean, message?: string }}
 */
export function validateExecuteWithin(value) {
  if (value === "" || value === undefined) {
    return { ok: false, message: apiT(K.API_SVC_EXECUTE_WITHIN_RANGE) };
  }
  const n = Number(value);
  if (!Number.isInteger(n) || n < 1 || n > 9999) {
    return { ok: false, message: apiT(K.API_SVC_EXECUTE_WITHIN_WHOLE) };
  }
  return { ok: true };
}

/** Convert execute-within + unit to milliseconds for backend persistence. */
export function toMilliseconds(amount, unit) {
  const n = Number(amount) || 0;
  if (unit === "sec") return n * 1000;
  if (unit === "min") return n * 60 * 1000;
  return n;
}
